/**
 * Restock urgency tiers rule card per scope §6.6.4. Atlas Day 3a P1.
 *
 * Surface per Sol D-2 lock 2026-05-27: "ISG flags inventory for restock
 * below tightness thresholds. Red = 1.0× lead time, Yellow = 1.5× lead
 * time (RPC-default fallbacks; not currently DB-configurable). Tighter =
 * more aggressive replenishment posture."
 *
 * D-2 substrate model: restock urgency multipliers consumed via RPC-default
 * COALESCE-fallback in forecast_restock + siblings (defaults 1.0 + 1.5; NOT
 * DB-stored at current state). BACKLOG candidate for Day 3b sweep —
 * restock urgency multipliers as DB-stored params (configurability-substrate
 * gap; post-launch).
 *
 * Click handler navigates to inspect view per Atlas Day 2.5 P1 URL routing.
 */

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingDown } from 'lucide-react';

// Hard-coded RPC-default values per D-2 lock (verified Phase 0 #10 from
// supplemental_rpcs_path_config.sql:587-588 + day75_dropship:1203-1204 +
// forecast_restock.sql:51 COALESCE-fallback defaults)
const RPC_DEFAULT_RED_MULTIPLIER = 1.0;
const RPC_DEFAULT_YELLOW_MULTIPLIER = 1.5;

export default function RestockUrgencyTiersCard(): JSX.Element {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      data-sub-region-id="restock-urgency-tiers"
      onClick={() => navigate('/admin/engine-atlas/inspect/restock-urgency-tiers')}
      className="w-full text-left border border-border-subtle bg-surface-0 rounded-md p-3 hover:border-accent transition-colors cursor-pointer"
    >
      <div className="flex items-start gap-2">
        <TrendingDown size={16} className="text-ink-secondary flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-ink-bright">Restock urgency tiers</h3>
          <p className="text-xs text-ink-secondary mt-1">
            ISG flags inventory for restock below tightness thresholds. Red ={' '}
            {RPC_DEFAULT_RED_MULTIPLIER}× lead time, Yellow = {RPC_DEFAULT_YELLOW_MULTIPLIER}×
            lead time (RPC-default fallbacks; not currently DB-configurable). Tighter = more
            aggressive replenishment posture.
          </p>
        </div>
      </div>
    </button>
  );
}
